export default "__VITE_ASSET__CcY3QlZF__"